import React from 'react';
import PropTypes from 'prop-types';
import ChartistGraph from 'react-chartist';
import PieChart from '@material-ui/icons/PieChart';
import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import chartsStyle from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx';
import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
} from 'assets/jss/material-dashboard-pro-react.jsx';

const styles = () => ({
  slice0: {
    stroke: primaryColor,
    color: primaryColor,
  },
  slice1: {
    stroke: warningColor,
    color: warningColor,
  },
  slice2: {
    stroke: dangerColor,
    color: dangerColor,
  },
  slice3: {
    stroke: successColor,
    color: successColor,
  },
  slice4: {
    stroke: infoColor,
    color: infoColor,
  },
  ...chartsStyle,
});

const TicketPoolDonut = ({ ticketsCount, classes }) => {
  function getClass(key) {
    if (key === 0) {
      return classes.slice0;
    } else if (key === 1) {
      return classes.slice1;
    } else if (key === 2) {
      return classes.slice2;
    } else if (key === 3) {
      return classes.slice3;
    } else {
      return classes.slice4;
    }
  }

  const totalCount = ticketsCount.reduce(
    (count, tickets) => count + tickets.count,
    0
  );
  if (!totalCount) {
    return null;
  }
  const data = ticketsCount.reduce(
    (accData, tickets, index) => {
      const percentage = (tickets.count / totalCount) * 100;
      return {
        labels: [...accData.labels, `${percentage.toFixed(2)}%`],
        series: [
          ...accData.series,
          {
            value: percentage.toFixed(2),
            className: classes['slice' + index],
          },
        ],
      };
    },
    {
      labels: [],
      series: [],
    }
  );
  return (
    <Card>
      <CardHeader color="danger" icon>
        <CardIcon color="danger">
          <PieChart />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Tickets pro Pool</h4>
      </CardHeader>
      <CardBody>
        <ChartistGraph
          style={{ fontWeight: 'bold' }}
          data={data}
          type="Pie"
          options={{
            height: '200px',
            donut: true,
            showLabel: true,
            donutSolid: true,
            classNames: {
              label: classes.pieLabel,
            },
          }}
        />
      </CardBody>
      <CardFooter stats className={classes.cardFooter}>
        <h6 className={classes.legendTitle}>Legende</h6>
        {ticketsCount.map((tickets, key) => {
          return (
            <span key={key}>
              <i className={'fas fa-circle ' + getClass(key)} />{' '}
              {tickets.pool + ' '}
            </span>
          );
        })}
      </CardFooter>
    </Card>
  );
};

TicketPoolDonut.defaultProps = {
  ticketsCount: [],
};

TicketPoolDonut.propTypes = {
  ticketsCount: PropTypes.array,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TicketPoolDonut);



// WEBPACK FOOTER //
// ./src/views/skidata/components/TicketPoolDonut.jsx